import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Container } from '../components/common/Container';
import { PlansCarousel } from './PlansCarousel';

const HOST_PLANS = [
  {
    id: 'starter', name: 'Starter', price: '4,99', badge: null, cta: 'Inizia ora',
    tagline: 'Il necessario per accogliere i tuoi ospiti online.',
    includes: [
      'Pagina personalizzata della struttura',
      'Assistente digitale per gli ospiti (QR + PIN)',
      'Sezioni Eventi, Vicino a te, Arte & Musei',
      'Gestione autonoma dei contenuti',
      'Multilingua (IT/EN/DE/FR)',
      'Assistenza via email',
    ],
  },
  {
    id: 'business', name: 'Business', price: '9,99', badge: 'Più scelto', cta: 'Prova gratis',
    tagline: 'Tutto Starter, con più strumenti e personalizzazione.',
    includes: [
      'Tutto il piano Starter',
      'Sezione Servizi della struttura',
      'Personalizzazione colori e branding',
      'Banner e comunicazioni agli ospiti',
      'Statistiche scansioni QR',
      'Assistenza prioritaria',
    ],
  },
  {
    id: 'premium', name: 'Premium', price: '14,99', badge: null, cta: 'Passa a Premium',
    tagline: 'Tutto Business, con la massima visibilità e supporto.',
    includes: [
      'Tutto il piano Business',
      'Sezione Esperienze',
      'Partner e convenzioni locali',
      'Analytics avanzate',
      'Massima priorità e visibilità',
      'Supporto dedicato',
    ],
  },
];

export function HostPlansSection() {
  return (
    <section id="prezzi" className="py-14 md:py-20" data-testid="host-plans-section">
      <Container>
        <div className="text-center">
          <h2 className="font-display text-3xl text-paelbi-ink md:text-[32px]">Scegli il piano giusto per te</h2>
          <p className="mt-3 font-sans text-base text-paelbi-ink/70">Prezzi semplici e trasparenti. Cresci quando vuoi.</p>
        </div>

        <PlansCarousel plans={HOST_PLANS} ctaTo={() => '/onboarding'} testidPrefix="host-plan" />

        <p className="mt-8 flex items-center justify-center gap-2 font-sans text-sm text-paelbi-ink/60">
          <ShieldCheck size={16} className="text-paelbi-brown" />
          30 giorni di prova, nessun vincolo. Disdici quando vuoi.
        </p>
      </Container>
    </section>
  );
}

export default HostPlansSection;
